export const FETCH_PARKED_VISITS = "[TYPIST] FETCH_PARKED_VISITS";
export const FETCH_PARKED_VISITS_START = "[TYPIST] FETCH_PARKED_VISITS_START";
export const FETCH_PARKED_VISITS_SUCCESS = "[TYPIST] FETCH_PARKED_VISITS_SUCCESS";
export const FETCH_PARKED_VISITS_ERROR = "[TYPIST] FETCH_PARKED_VISITS_ERROR";

export const VIEW_PARKED_VISIT = "[TYPIST] VIEW_PARKED_VISIT";
export const VIEW_PARKED_VISIT_START = "[TYPIST] VIEW_PARKED_VISIT_START";
export const VIEW_PARKED_VISIT_SUCCESS = "[TYPIST] VIEW_PARKED_VISIT_SUCCESS";
export const VIEW_PARKED_VISIT_ERROR = "[TYPIST] VIEW_PARKED_VISIT_ERROR";

export const SET_PARKED_SEARCH_FILTER_AND_SORT = "[TYPIST] SET_PARKED_SEARCH_FILTER_AND_SORT";
export const SET_PARKED_VISIT_PAGINATION = "[TYPIST] SET_PARKED_VISIT_PAGINATION";
export const RESET_TYPIST_PARKED_FILTER = "[TYPIST] RESET_TYPIST_PARKED_FILTER";
export const SET_PARKED_AUTO_NEXT_VISIT = "[TYPIST] SET_PARKED_AUTO_NEXT_VISIT";

export const setParkedSearchFilterAndSort = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_PARKED_SEARCH_FILTER_AND_SORT,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const getParkedVisits = (payload) => {
    return {
        type: FETCH_PARKED_VISITS,
        payload
    };
};

export const viewParkedVisit = (visit) => {
    return {
        type: VIEW_PARKED_VISIT,
        visit
    };
}

export const resetTypistParkedFilter = () => {
    return {
        type: RESET_TYPIST_PARKED_FILTER,
    };
}

export const setParkedAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_PARKED_AUTO_NEXT_VISIT,
        autoNextVisit
    };
}
